<header class="header">
  <div class="logo" *ngIf="isUserLoggedIn">
    <img src="assets/Application Logo.svg" alt="Application logo" class="app-logo" />
  </div>
  
  <div class="header-controls" *ngIf="isUserLoggedIn">
    <div class="profile-selector" *ngIf="isOnBatchRoute">
      <div class="profile-pill">
        <span class="profile-pill-text">Profile:</span>
        <rds-select
          class="profile-select profile-select--pill"
          placeholder="Select Application"
          [(ngModel)]="selectedProfile"
          (ngModelChange)="onProfileChange($event)"
          required
        >
          <!-- <rds-option value="" disabled>Select Application</rds-option> -->
          <rds-option *ngFor="let profile of availableProfiles" [value]="profile.value">
            {{ profile.viewValue || profile.value }}
          </rds-option>
        </rds-select>
      </div>
    </div>

    <span class="icon-label" (click)="logout()">
      <rds-icon name="rds-icon-power"></rds-icon>
      <span class="profile-label">Logout</span>
    </span>
  </div>
</header>
